import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { ServiceHistoryModal } from 'entities/service-history';
import { FC, MouseEvent, useState } from 'react';
import { useIframeDialogStore } from 'widgets/iframe-dialog';

export const LinksCell: FC<{ data?: WarrantyLogModel }> = ({ data }) => {
  const [showServiceHistoryModal, setShowServiceHistoryModal] = useState<boolean>();
  const { open: openDigitalWipModal } = useIframeDialogStore();
  const openDigitalWip = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openDigitalWipModal(`/digital-wip-view/${data?.soHeaderId}`);
  };

  const openServiceHistory = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowServiceHistoryModal(true);
  };

  return (
    <>
      <div className="d-flex flex-column gap-2">
        {Boolean(data?.soHeaderId) && (
          <div>
            <a href="#" className={styles.linkBlock} onClick={openDigitalWip}>
              <InlineSvg path="/media/icons/custom/cif-open.svg" className="me-1" />
              Digital WIP
            </a>
          </div>
        )}

        <div>
          <a href={'#'} target="_blank" rel="noopener noreferrer" className={styles.linkBlock}>
            <InlineSvg path="/media/icons/duotune/files/fil003.svg" className="me-1" />
            Check In PDF
          </a>
        </div>

        {Boolean(data?.technicianJobId) && (
          <div>
            <a
              href={`https://qs.advance-motors.co.uk/DigitalWip/GetDigitalWip/${data?.soHeaderId}?tab=tech`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.linkBlock}
            >
              <InlineSvg path="/media/icons/duotune/files/fil003.svg" className="me-1" />
              Technician Job PDF
            </a>
          </div>
        )}

        <div>
          <a href={'#'} className={styles.linkBlock} onClick={openServiceHistory}>
            <InlineSvg path="/media/icons/custom/cif-open.svg" className="me-1" />
            Service History
          </a>
        </div>
      </div>
      {showServiceHistoryModal && (
        <ServiceHistoryModal onClose={() => setShowServiceHistoryModal(false)} regNo={data?.regno ?? undefined} />
      )}
    </>
  );
};
